import { Component, Prop, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import { MediaCollection } from '@shared/interfaces/inputs';

@Component({
  name: 'bpc-exact-auth-link',
  components: {
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class ExactAuthLink extends mixins(AbstractField) {
  @Prop(Object) readonly exactParams: { client_id: string; redirect_uri: string; auth_url: string };
  @Prop({ type: String }) readonly uxSessionCode: string;

  get loginUrl(): string {
    const authUrl = this.exactParams?.auth_url || '';
    const redirectURI = this.exactParams?.redirect_uri || '';
    const clientId = this.exactParams?.client_id || '';

    return `${authUrl}?client_id=${clientId}&redirect_uri=${redirectURI}&response_type=code&force_login=0&state=${this.exactStateStr}`;
  }

  get exactStateStr(): string {
    const state = {
      tenantId: this.tenantId,
      sessionCode: this.uxSessionCode || 'not_provided',
      lang: this.$store.getters['auth/userLang'],
    };

    const stateStr = encodeURI(JSON.stringify(state));

    return stateStr;
  }

  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }
}
